import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import withAdminLayout from '../../layout/withUserLayout';
import Manuals from './manuals';
import Newsletter from './newsletter';

const UserPanel = lazy(() => import('../../container/crud/userPanel/Index'));
const AdminProfile = lazy(() => import('../../container/crud/adminProfile/index'));

const Panel = () => {
  const { path } = useRouteMatch();
  console.log("entrando a user panel",  path );
  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <Route exact path={`${path}`} component={UserPanel} />
        <Route exact path={`${path}/admin-profile`} component={AdminProfile}/>

        {/* <Route path={`${path}/manuals`} component={Manuals} />
        <Route path={`${path}/newsletter`} component={Newsletter} /> */}
      </Suspense>
    </Switch>
  );
};

export default withAdminLayout(Panel);
